import store from 'store'

import { API__USER, API__PAYMENTS, API__PRODUCTS } from 'api'

import { tryGetAuthInfo } from 'utils/authInfoRecover'

import { AUTH__LOGIN_RESTORE, AUTH__LOGOUT } from 'store/actions'

const PERMITTED_DOMAINS = [new URL(process.env.REACT_APP_SSR_URL).origin]

const AVAILABLE_METHODS = {
    CHECK_USER_CREDENTIALS: 'CHECK_USER_CREDENTIALS',
    LOGOUT: 'LOGOUT',
    GET_USER_DETAILS: 'GET_USER_DETAILS',
    GET_USER_SUBSCRIPTION: 'GET_USER_SUBSCRIPTION',
    GET_PAYMENT_LINK: 'GET_PAYMENT_LINK',
    GET_SUBSCRIPTION_CHANGING_RULES: 'GET_SUBSCRIPTION_CHANGING_RULES',
}

const METHOD_AUTHORIZATION_REQUIRED = {
    [AVAILABLE_METHODS.CHECK_USER_CREDENTIALS]: false,
    [AVAILABLE_METHODS.LOGOUT]: true,
    [AVAILABLE_METHODS.GET_USER_DETAILS]: true,
    [AVAILABLE_METHODS.GET_USER_SUBSCRIPTION]: true,
    [AVAILABLE_METHODS.GET_PAYMENT_LINK]: true,
    [AVAILABLE_METHODS.GET_SUBSCRIPTION_CHANGING_RULES]: true,
}

const handlePostMessage = async ({ origin, source, data: { method, requestId, params } = {} }) => {
    if (!PERMITTED_DOMAINS.includes(origin)) return

    let result = null,
        error = null

    if (!AVAILABLE_METHODS[method]) error = createError(400, `Method not found: ${method}`)

    const authInfo = tryGetAuthInfo()
    if (authInfo) store.dispatch(AUTH__LOGIN_RESTORE(authInfo))

    const isHasCredentials = !!authInfo
    const userId = isHasCredentials ? parseInt(authInfo.user.id) : null

    if (METHOD_AUTHORIZATION_REQUIRED[method] && !isHasCredentials)
        error = createError(401, `User is unauthorized, method: ${method}`)

    if (!error) {
        try {
            result = await handleMethod({ method, userId, params })
        } catch (err) {
            error = createError(err.response.status, err.message)
        }
    }
    source.postMessage(
        {
            requestId,
            result,
            error,
        },
        origin,
    )
}

const handleMethod = async ({ method, userId, params }) => {
    switch (method) {
        case AVAILABLE_METHODS.CHECK_USER_CREDENTIALS: {
            return {
                isHasCredentials: !!userId,
                userId,
            }
        }
        case AVAILABLE_METHODS.LOGOUT: {
            store.dispatch(AUTH__LOGOUT())
            return
        }
        case AVAILABLE_METHODS.GET_USER_DETAILS: {
            return await API__USER.GET_DETAILS(userId)
        }
        case AVAILABLE_METHODS.GET_USER_SUBSCRIPTION: {
            return await API__USER.GET_SELECTED_SUBSCRIPTION(userId)
        }
        case AVAILABLE_METHODS.GET_PAYMENT_LINK: {
            const { productCode, couponCode } = params
            return await API__PAYMENTS.GET_PAYMENT_LINK({ productCode, couponCode })
        }
        case AVAILABLE_METHODS.GET_SUBSCRIPTION_CHANGING_RULES: {
            return await API__PRODUCTS.GET_PRODUCT_CHANGED_RULES()
        }
        default:
            throw new Error(`Method not found: ${method}`)
    }
}

const createError = (statusCode, message) => {
    return { statusCode, message }
}

const initialize = () => window.addEventListener('message', handlePostMessage)
const destroy = () => window.removeEventListener('message', handlePostMessage)

export default {
    initialize,
    destroy,
}
